interface HeroAcceleracaoProps {
  onOpenModal: () => void;
}

export default function HeroAcceleracao({ onOpenModal }: HeroAcceleracaoProps) {
  return (
    <section className="relative min-h-[600px] sm:min-h-[700px] lg:min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/images/topo1.jpeg')`
        }}
      />
      
      <div className="container relative z-10">
        <div className="grid lg:grid-cols-[1.2fr_0.8fr] gap-8 lg:gap-16 items-center py-12 sm:py-16 lg:py-20 px-4">
          {/* Coluna Esquerda - Conteúdo */}
          <div className="text-white space-y-8 sm:space-y-10">
            {/* Headline */}
            <div className="space-y-4 sm:space-y-6">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
                Impulsione seu faturamento com uma agência que gera
                <span className="block gradient-text-orange mt-3">
                  + de R$30 milhões de vendas para seus parceiros ao ano
                </span>
              </h1>
              
              <div className="text-lg sm:text-xl md:text-2xl text-white leading-relaxed mt-6 sm:mt-8">
                <p className="font-medium">
                  Descubra como nossos parceiros estão aumentando até 3x suas vendas usando CRM, automação e inteligência artificial no marketing e no atendimento.
                </p>
              </div>
            </div>
            
            {/* CTA */}
            <div className="pt-4">
              <button 
                onClick={onOpenModal}
                className="bg-green-600 hover:bg-green-700 text-white text-base sm:text-lg md:text-xl px-8 sm:px-12 py-4 sm:py-6 rounded-xl font-bold transition-all duration-300 cursor-pointer w-full sm:w-auto shadow-xl hover:shadow-2xl"
              >
                <i className="ri-calendar-line mr-2"></i>
                AGENDAR REUNIÃO
              </button>
            </div>

            {/* Credenciais */}
            <div className="flex items-center gap-6 sm:gap-8 pt-8 sm:pt-10">
              <div className="flex flex-col">
                <div className="text-xl sm:text-2xl md:text-3xl font-bold text-white">
                  1.500
                </div>
                <div className="text-xs sm:text-sm text-gray-300 mt-1">
                  empresas atendidas
                </div>
              </div>
              
              <div className="w-px h-12 sm:h-14 bg-orange-500"></div>
              
              <div className="flex flex-col">
                <div className="text-xl sm:text-2xl md:text-3xl font-bold text-white">
                  + de 10 anos
                </div>
                <div className="text-xs sm:text-sm text-gray-300 mt-1">
                  de mercado
                </div>
              </div>
            </div>
          </div>
          
          {/* Coluna Direita - Espaço para foto do background */}
          <div className="hidden lg:block relative h-full min-h-[500px]">
            {/* A foto do background aparece aqui naturalmente */}
          </div>
        </div>
      </div>
    </section>
  );
}
